import { Stack } from '@mui/material';
import { TextInformation } from './TextInformation';
import { CustomStepperWithLabels } from 'Components/CustomStepperWithLabels';
import { ClaimEvent } from 'API';
import {
  getLabelStyle,
  getStepIcon,
} from 'Utils/recognitionStatusHelperFunctions';
import { useIsDesktop } from 'Hooks';
import { IClaimEventSteps } from '..';

interface IProgressAndInformation {
  latestEvent: ClaimEvent | undefined;
  claimEventSteps: IClaimEventSteps[];
  currentStepIndex: number;
}

export const ProgressAndInformation = ({
  latestEvent,
  claimEventSteps,
  currentStepIndex,
}: IProgressAndInformation) => {
  const isDesktop = useIsDesktop();

  const textInformationComponent: React.ReactNode = (
    <TextInformation
      currentStepIcon={getStepIcon(
        latestEvent?.treatStepsGroupId,
        latestEvent?.decisionType
      )}
      informationLabel={claimEventSteps[currentStepIndex]?.name}
    />
  );

  return (
    <Stack direction='row' justifyContent='space-between'>
      <CustomStepperWithLabels
        steps={claimEventSteps}
        currentStepIndex={currentStepIndex}
        currentStepLabelSx={{
          ...getLabelStyle(
            latestEvent?.treatStepsGroupId,
            latestEvent?.decisionType
          ),
          mb: isDesktop ? undefined : '12px',
        }}
        textLabelComponent={isDesktop ? null : textInformationComponent}
      />
      {isDesktop && textInformationComponent}
    </Stack>
  );
};
